






















import CListGroupItem from '~/components/shared/configurable/list-group/CListGroupItem.vue'
import CExternalLinkMediatorModal from '~/components/shared/configurable/modal/CExternalLinkMediatorModal.vue'
import { ciExternalLink } from '~/icons/source/regular/external-link'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  components: { CExternalLinkMediatorModal, CListGroupItem },
  props: {
    title: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: true
    },
    target: {
      type: String,
      required: false,
      default: null
    },
    useRouter: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      externalLinkMediatorUrl: '',
      showExternalLinkMediator: false
    }
  },
  computed: {
    icons() {
      return {
        link: ciExternalLink
      }
    }
  },
  methods: {
    onClick(e: Event) {
      if (!this.useRouter) {
        e.preventDefault()
        this.externalLinkMediatorUrl = this.link
        this.showExternalLinkMediator = true
      }
    }
  }
})
